interface RadioButtonProps {
  label: string;
  disabled?: boolean;
  id: string;
  [key: string]: any;
}

const RadioButton = ({ label, disabled, id, ...rest }: RadioButtonProps) => {
  return (
    <div className="flex items-center gap-2">
      <input
        type="radio"
        id={id}
        disabled={disabled}
        className="m-0 h-[1.1em] w-[1.1em] cursor-pointer accent-accent disabled:cursor-not-allowed disabled:accent-disabled border-primary"
        {...rest}
      />
      <label
        htmlFor={id}
        className={`whitespace-nowrap text-default font-medium ${disabled ? "cursor-not-allowed" : ""}`}
      >
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
